import { PagePlugin, ComponentData } from '@accedo/page';
import { VERTICAL, OnScrollOpt } from '@accedo/virtual-scroll';
import { ModalLauncher } from '@accedo/modal';
import { ComponentTypes } from '##/utils/types';
import { focusCache } from '##/services/store/store';
import { nav } from '##/init';
import { setLoadingIndicatorVisibility } from '##/components/LoadingIndicator/LoadingIndicator';
import { tryAssignFocus } from '##/utils';

const afterInitialScroll = async (): Promise<void> => {
  if (!ModalLauncher.isModalOpen()) {
    const { lastFocusId } = focusCache.home.$get();
    const defaultFocusId = 'page-scroll';
    if (lastFocusId) {
      try {
        await nav.assignFocus(lastFocusId);
      } catch (err) {
        await tryAssignFocus(defaultFocusId);
      }
    } else {
      await tryAssignFocus(defaultFocusId);
    }
  }
  setLoadingIndicatorVisibility?.(false);
};

export const addPageScroll: PagePlugin = ({ data }): ComponentData[] => {
  const { scrollToPrevious, lastScrollPosition } = focusCache.home.$get();
  const newData: ComponentData = {
    cType: ComponentTypes.PageScroll,
    props: {
      children: data,
      id: 'page-scroll',
      navProps: {
        refocusOnUnmount: false,
      },
      scrollProps: {
        animate: true,
        afterInitialScroll,
        initialScrollIndex: (scrollToPrevious && lastScrollPosition) || 0,
        lazyLoadBoundary: 2,
        onScroll: ({ index }: OnScrollOpt) => {
          focusCache.home.$set({
            lastScrollPosition: index,
          });
        },
        orientation: VERTICAL,
      },
    },
  };
  return [newData];
};
